import React from 'react';
import { RESOURCES_ENDPOINT } from "@icarius-connection/endpoints";
import { IconButton } from '@material-ui/core';
import { VisibilityIcon } from '@icarius-icons/index';
import { previewFromURL } from '@icarius-utils/download';

const PreviewFileRenderer = ({ value, column }) => {
    return (
        Boolean(value) ?
            <div
                style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer' }}
                onClick={() => previewFromURL(RESOURCES_ENDPOINT + value, column.colId)}
            >
                <IconButton style={{ height: 24 }}>
                    <VisibilityIcon />
                </IconButton>
            </div>
            : <div />
    );
}

export default PreviewFileRenderer;